;(function() {
    // npm run dev          process.argv.splice(2)[0] : undefined   process.env.NODE_ENV : development
    // npm run build local  process.argv.splice(2)[0] : local       process.env.NODE_ENV : production
    // npm run build pre    process.argv.splice(2)[0] : pre         process.env.NODE_ENV : production
    // npm run build        process.argv.splice(2)[0] : undefined   process.env.NODE_ENV : production
    // var type = process.argv.splice(2)[0] || (process.env.NODE_ENV === 'development' ? 'dev' : 'prod');
    var type = process.env.MODE; // MODE: dev / test / pre / prod
    if(type === 'dev' || type === 'test') { // test
        // window.Global_appid="wxbda8d63c3f0bfe8f";
        window.Global_appid="wxc9da5906be07cd86"; // 李耀刚测试号
        window.Default_openid="";
        window.Debug_mode="";
        window.SERVICE_DOMAIN_NAME="http://demobosapi.liangyihui.net";
        window.CONFIGDOC=[39510,39511];
      //window.RONGYUN_APPKEY="y745wfm84aemv";
        window.TIM_APPKEY=1400495465;
        window.MiniProgram_Type = 'trial' //小程序类型--体验版
        window.Global_proxyapi="http://demom.liangyihui.net/doctor/php/api.php";
        window.Global_root_path_wx="http://office.liangyihui.net/";
        window.Global_apiserver="https://demohdtapi.liangyihui.net/";
        window.Global_apidtserver="https://demohdtapi.liangyihui.net/";
        window.Global_ambApiServer="https://demohdtapi.liangyihui.net/";
        window.Global_wxappserver="https://demom.liangyihui.net/doctor/";
        window.Global_ShareServer="https://demom.liangyihui.net/doctor/dve/";
        window.Global_root_path="https://demom.liangyihui.net/";
        window.Global_nodeserver="https://demo.liangyihui.net"; // 拉取json配置禁止使用此变量！！！ 统一使用Global_AliJson_path！！！
        window.H_APISERVER="https://demoapi.liangyihui.net/";
        window.W_APISERVER="https://demohdtapi.liangyihui.net/";
        window.Global_qiniuup="https://upload.qbox.me/";
        window.GAS="https://demohdtapi.liangyihui.net/";
        window.Global_AliJson_path="https://json.liangyihui.net/dev/";
        window.Global_AliFormData="https://foralilog.liangyihui.net/";
        window.Global_cdn_api="https://demohdtapi.liangyihui.net/";
        window.Global_NewBos_api="https://demodtbos2api.liangyihui.net/";
        window.Global_patient_apiserver="http://demopatient.liangyihui.net/";
        window.Global_lyhccapiserver="//demolyhccapi.liangyihui.net/";
        window.Global_ActivetyApiServer = 'https://demoactivityapi.liangyihui.net/';
        window.Global_uni_tools="https://demotools.liangyihui.net/";
        window.Global_newPatient_serve="https://demopmapi.liangyihui.net/";
        window.Global_aicase_url="https://cdnmini.liangyihui.net/aicasedemo";
        window.Global_Lc='https://demolc.liangyihui.net/';
        window.Global_jsk_url='https://jsk.liangyihui.net/?type=demodoctor';
        window.Global_userCenter_serve='https://demouc.liangyihui.net/';
        window.Global_resolution_serve='https://app-data-test.liangyihui.net/';
        window.Global_study_serve='https://demoedusohoapi.liangyihui.net/';
        window.Global_yanzhiquan_serve='https://demoedu.liangyihui.net/';
        window.Global_function_serve = 'https://demohcft.liangyihui.net/'
        window.Global_YZQ_serve = 'https://demom.yanzhiquan.net/'
        window.Global_Document_serve = 'https://demodocument.yanzhiquan.net/'

        window.Global_Sensors_Server = 'https://sensorsdata.liangyihui.net/sa?project=default'
        window.Global_doctorapple_server = 'https://demodoctorappletapi.liangyihui.net'
        // 互联网医院
        window.Glabal_lyhcc_path = 'https://demolyhccminih5.lyhcc.cn/#/'
        window.Glocal_Login_Server = 'https://demologin.liangyihui.net/'
        window.Global_aicase = "https://cdnmini.liangyihui.net/aicasedemo"; //ai病历夹
    } else if (type === 'pre') { // pre
        window.Global_appid="wxee6970ed94d3da53";
        //window.RONGYUN_APPKEY="p5tvi9dstzwd4";
        window.TIM_APPKEY=1400514045;
        window.CONFIGDOC=[39510,39511];
        window.MiniProgram_Type = 'trial' //小程序类型--体验版
        window.Global_apiserver="https://predtapi.liangyihui.net/";
        window.Global_apidtserver="https://predtapi.liangyihui.net/";
        window.Global_ambApiServer="https://predtapi.liangyihui.net/";
        window.Global_ActivetyApiServer='https://activityapi.liangyihui.net/';
        window.Global_lyhccapiserver="//prelyhccapi.liangyihui.net/";
        window.Global_jsk_url='https://jsk.liangyihui.net/?type=prddoctor';
        window.Global_study_serve='https://edusohoapi.liangyihui.net/release/';
        window.Global_yanzhiquan_serve='https://edu.liangyihui.net/';
        window.Global_doctorapple_server = 'https://predoctorappletapi.liangyihui.net'
        // 七牛云、阿里云
        window.Global_qiniuup="https://up-z2.qiniup.com/";
        window.Global_AliFormData="https://foralilog.liangyihui.net/";
        window.Global_AliJson_path="https://json.liangyihui.net/pre/";
        window.Global_cdn_api="https://prdapicdn.liangyihui.net/";
        // 待迁移
        window.Global_wxappserver="https://predoctor.liangyihui.net/doctor/";
        window.Global_nodeserver="https://preweb.liangyihui.net";
        // 前端
        window.Global_root_path="https://predoctor.liangyihui.net/";
        window.Global_uni_tools="https://pretools.liangyihui.net/";
        window.Global_aicase_url="https://cdnmini.liangyihui.net/aicasedemo";
        window.Global_Lc='https://prelc.liangyihui.net/';
        window.Global_userCenter_serve='https://preuc.liangyihui.net/';
        // 待合并
        window.H_APISERVER="https://preapi.liangyihui.net/";
        window.W_APISERVER="https://predtapi.liangyihui.net/";
        window.GAS="https://predtapi.liangyihui.net/";
        window.Global_function_serve = 'https://preprodft.liangyihui.net/'

        window.Global_Sensors_Server = 'https://sensorsdata.liangyihui.net/sa?project=default'
        // 互联网医院
        window.Glabal_lyhcc_path = 'https://demolyhccminih5.lyhcc.cn/#/'
        window.Glocal_Login_Server = 'https://prelogin.liangyihui.net/'

        window.Global_aicase = "https://cdnmini.liangyihui.net/aicase";//ai病历夹
    } else { // prod
        window.Global_appid="wxee6970ed94d3da53";
        window.Default_openid="";
        window.Debug_mode="";
        window.SERVICE_DOMAIN_NAME="http://bos.liangyihui.net";
        window.CONFIGDOC=[39510,39511];
      //window.RONGYUN_APPKEY="p5tvi9dstzwd4";
        window.TIM_APPKEY=1400494878;
        window.MiniProgram_Type = 'release' //小程序类型--正式版
        window.Global_proxyapi="http://doctor.liangyihui.net/doctor/php/api.php";
        window.Global_root_path_wx="http://patient.liangyihui.net/";
        window.Global_apiserver="https://hdtapi.liangyihui.net/";
        window.Global_apidtserver="https://hdtapi.liangyihui.net/";
        window.Global_ambApiServer="https://hdtapi.liangyihui.net/";
        window.Global_wxappserver="https://doctor.liangyihui.net/doctor/";
        window.Global_ShareServer="https://doctor.liangyihui.net/doctor/dve/";
        window.Global_root_path="https://doctor.liangyihui.net/";
        window.Global_nodeserver="https://web.liangyihui.net"; // 拉取json配置禁止使用此变量！！！ 统一使用Global_AliJson_path！！！
        window.H_APISERVER="https://api.liangyihui.net/";
        window.W_APISERVER="https://hdtapi.liangyihui.net/";
        window.Global_qiniuup="https://upload.qbox.me/";
        window.GAS="https://hdtapi.liangyihui.net/";
        window.Global_AliJson_path="https://json.liangyihui.net/prd/";
        window.Global_AliFormData="https://foralilog.liangyihui.net/";
        window.Global_cdn_api="https://prdapicdn.liangyihui.net/";
        window.Global_NewBos_api="https://bos3api.liangyihui.net/";
        window.Global_patient_apiserver="http://patient.liangyihui.net:8080/PatientApiServer/";
        window.Global_lyhccapiserver="//lyhccapi.liangyihui.net/";
        window.Global_ActivetyApiServer='https://activityapi.liangyihui.net/';
        window.Global_uni_tools="https://tools.liangyihui.net/";
        window.Global_aicase_url="https://cdnmini.liangyihui.net/aicase";
        window.Global_newPatient_serve="https://pmapi.liangyihui.net/";
        window.Global_Lc='https://lc.liangyihui.net/';
        window.Global_jsk_url='https://jsk.liangyihui.net/?type=prddoctor';
        window.Global_userCenter_serve='https://uc.liangyihui.net/';
        window.Global_resolution_serve='https://app-data-prod.liangyihui.net/';
        window.Global_study_serve='https://service-eht1jn39-1254305131.sh.apigw.tencentcs.com/release/';
        window.Global_yanzhiquan_serve='https://edu.liangyihui.net/';
        window.Global_function_serve = 'https://hcft.liangyihui.net/'
        window.Global_YZQ_serve = 'https://m.yanzhiquan.net/'
        window.Global_Document_serve = 'https://document.yanzhiquan.net/'
        window.Global_Sensors_Server = 'https://sensorsdata.liangyihui.net/sa?project=production'
        window.Global_doctorapple_server = 'https://doctorappletapi.liangyihui.net'
        window.Glabal_lyhcc_path = 'https://lyhccminih5.lyhcc.cn/#/'
        window.Glocal_Login_Server = 'https://login.liangyihui.net/'

        window.Global_aicase = "https://cdnmini.liangyihui.net/aicase";//ai病历夹
    }
})();
